import styles from '../styles.module.scss';
import { FeeProps } from '../props';
import skeleton from './styles.module.scss';

export default function FeeSkeleton({ noChain }: FeeProps) {
  return (
    <div className={styles.container}>
      {Array.from({ length: noChain ? 1 : 2 }).map((_, index) => (
        <div className={styles.container__row} key={`fee-skeleton-${index}`}>
          <p className={styles.container__label}>
            <div className={skeleton.label} />
          </p>

          <p className={styles.container__value}>
            <div className={skeleton.value} />
          </p>
        </div>
      ))}
    </div>
  );
}
